export type AuthResultStatus = 'success' | 'activation_required' | 'error';

export class AuthResult {
  status!: AuthResultStatus;
  activationToken?: string;
  activationViaEmail?: boolean;

  constructor(data: Partial<AuthResult>) {
    Object.assign(this, data);
  }

  get isSuccess(): boolean {
    return this.status === 'success';
  }

  get isActivationRequired(): boolean {
    return this.status === 'activation_required';
  }

  get isError(): boolean {
    return this.status === 'error';
  }
}